import * as React from 'react';
export default function SvgRucksack() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.634 6a1 1 0 0 1 .866-.5h1a1 1 0 0 1 .866.5h-2.732ZM9.05 6a2.5 2.5 0 0 1 2.45-2h1a2.5 2.5 0 0 1 2.45 2h3.3a.75.75 0 0 1 .75.75v2.5c0 .507-.137.982-.377 1.39l1.312 5.96c.393 1.784-1.02 3.4-2.824 3.4H6.89c-1.803 0-3.217-1.616-2.824-3.4l1.312-5.96A2.737 2.737 0 0 1 5 9.25v-2.5A.75.75 0 0 1 5.75 6h3.3Zm7.2 6c.386 0 .754-.08 1.088-.223l1.132 5.146c.172.78-.443 1.577-1.359 1.577H6.89c-.916 0-1.53-.797-1.36-1.577l-.73-.16.73.16 1.134-5.146A2.74 2.74 0 0 0 7.75 12h3.5v1.25a.75.75 0 0 0 1.5 0V12h3.5Zm-3.5-1.5h3.5c.69 0 1.25-.56 1.25-1.25V7.5h-11v1.75c0 .69.56 1.25 1.25 1.25h3.5v-.75a.75.75 0 0 1 1.5 0v.75Z",
    fill: "currentColor"
  }));
}